// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2pakX","title":"Images90_title__nk8ys","images":"Images90_images__26krp"};